export default __webpack_public_path__ + "static/media/p-bar-chart.448fc809.jpg";